import { safeGet } from '../../core/utils/safe-get.js';
import type { AxisIdToScales } from '../context/XYChartScales.context.js';

export function getCurrentScale(
  axisIdToScales: AxisIdToScales,
  axisId: string,
) {
  return safeGet(axisIdToScales, axisId).currentScale;
}

export function getInitialScale(
  axisIdToScales: AxisIdToScales,
  axisId: string,
) {
  return safeGet(axisIdToScales, axisId).initialScale;
}
